import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Card, CloseButton, Dropdown, Form } from "react-bootstrap";

import Menu from "../../components/Menu";
import apiFormData from '../../apiFormData';
import api from '../../api';
import Swal from 'sweetalert2'
import Clear from '../../assets/img/remove.svg'
import InputImage from "../../components/InputImage";
import Validations from '../../Validations'
import LoadingBlock from "../../components/LoadingBlock";
import ModalYesNo from "../../components/ModalYesNo";
import Avatar from '../../assets/img/silhueta-de-multiplos-usuarios.svg'
import FooterEdit from "../../components/FooterEdit";

import { useStateContext } from '../../contexts/ContextProvider';
import InputCPF from "../../components/InputCPF";

function UsersEdit() {
    let { id } = useParams();
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)
    const [showModal, setShowModal] = useState(false)
    const [error, setError] = useState({
        name: false,
        email: false,
        password: false,
    })

    const [name, setName] = useState("")
    const [password, setPassword] = useState("")
    const [email, setEmail] = useState("")
    const [cpf, setCpf] = useState("")
    const [status, setStatus] = useState(true)

    const [roles, setRoles] = useState([])
    const [selectedRoles, setSelectedRoles] = useState([])

    const [isDoctor, setIsDoctor] = useState(false);
    const [professional, setProfessional] = useState({})
    const [isCashier, setIsCashier] = useState(false);

    const [professionalSearch, setProfessionalSearch] = useState("");
    const [professionalsList, setProfessionalsList] = useState([]);

    const [page, setPage] = useState(1);
    const [finalPage, setFinalPage] = useState(null);

    const [image, setImage] = useState({
        fileReal: '',
        file: ''
    })

    const { user } = useStateContext();

    useEffect(() => {
        const getRoles = async () => {
            await api.get('api/roles')
                .then(response => {
                    setRoles(response.data.data);
                })
                .catch(error => console.error(error))
        }

        getRoles()
    }, [])

    useEffect(() => {
        api.get('/api/users/' + id).then((response) => {
            var data = response.data.data
            setImage({
                fileReal: '',
                file: response.data.data.image
            })
            setName(data.name)
            setEmail(data.email)
            setStatus(data.status === null || data.status ? true : data.status)
            setSelectedRoles(data.roles)
            setIsDoctor(data.is_doctor)
            setProfessional(data.professional)
            setIsCashier(data.cashier_supervisor)
            setCpf(data.cpf ? data.cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4') : '');
        }).catch((error) => {
            console.error('Error fetching agreements:', error);
        }).finally(() => {

        })
    }, [id])

    const handleRoleChange = (role) => {
        const isSelected = selectedRoles.some(selectedRole => selectedRole.id === role.id);
    
        if (isSelected) {
            setSelectedRoles(selectedRoles.filter(selectedRole => selectedRole.id !== role.id));
        } else {
            setSelectedRoles([...selectedRoles, role]);
        }
    };    

    const addProfessional = (professional) => {
        setProfessional(professional);
    }

    const getProfessionals = (exception = false, page2 = null) => {
        // const listGroupElement = document.querySelector('.list-group');
        // listGroupElement.style.display = 'block';

        if (((page > finalPage && finalPage !== null) || loading) && exception === false) {
            // Já carregamos todas as páginas disponíveis ou esta carregando
            return;
        }

        if (professionalSearch !== "") {
            api.get('/api/professionals/search/' + professionalSearch + '?page=' + String(page2 === null ? page : page2)).then((response) => {

                //var professionals = response.data.data

                // for (const key in professionals) {
                //     professionals[key].cpf = professionals[key].cpf.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4")
                // }

                setProfessionalsList(page2 === null ? professionalsList.concat(response.data.data) : response.data.data)
                setFinalPage(response.data.meta.last_page)
                setPage(page + 1)
            }).catch((error) => {
                console.error('Error fetching professionals:', error);
            })
        } else {

            api.get('/api/professionals/listpages?page=' + String(page)).then((response) => {

                // var professionals = response.data.data

                // for (const key in professionals) {
                //     professionals[key].cpf = professionals[key].cpf.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4")
                // }

                setProfessionalsList(professionalsList.concat(response.data.data))
                setFinalPage(response.data.meta.last_page)
                setPage(page + 1)
            }).catch((error) => {
                console.error('Error fetching professionals:', error);
            })
        }
    }

    useEffect(() => {
        if (professionalSearch === "") {
            setFinalPage(null)
            setPage(1)
            setProfessionalsList([])
            getProfessionals()
        } else {
            getProfessionals(true, 1)
        }
    }, [professionalSearch])

    const onDelete = () => {
        setShowModal(false)
        setLoading(true)
        api.delete("/api/user/" + id).then((response) => {
            Swal.fire({
                title: "Usuário excluído com sucesso",
                icon: 'success',
                confirmButtonColor: '#3c8dbc',
            })
            setTimeout(() => {
                Swal.close()
                setTimeout(() => {
                    navigate('/users')
                }, 750);
            }, 1500);
        }).catch((error) => {
            console.error(error)
            Swal.fire({
                title: "Usuário não excluído",
                text: error.message,
                icon: 'error',
                confirmButtonColor: '#3c8dbc',

            })
        }).finally(() => {
            setLoading(false)
        })

    }

    const onSubmit = (ev) => {
        ev.preventDefault()
        var errors = {
          name: name.replaceAll(" ", "") === "" ? true : false,
          email: !Validations.emailValid(email),
          password: password !== "" ? (password.length < 3 ? true : false) : false,
          professional: isDoctor && (!professional) ? true : false,
          selectedRoles: (selectedRoles.length === 0) ? true : false
        };
        setError(errors)
        var validations = true

        for (const key in errors) {
            if (errors.hasOwnProperty(key) && errors[key] === true) {
                validations = false;
            }
        }

        if (validations) {
            var form = new FormData()
            image.fileReal !== '' ? form.set("image", image.fileReal) : console.log('')
            form.set("id", id)
            form.set("name", name);
            form.set("email", email);
            password !== " " ? form.set("password", password) : console.log('')
            form.set("cpf", cpf.replaceAll('.', '').replaceAll('-', ''));
            form.set("status", status);

            if (isDoctor) {
              form.set("professional_id", professional.id);
              form.set("is_doctor", isDoctor);
            }

            form.set("cashier_supervisor", isCashier);

            setLoading(true)
            apiFormData.post("/api/users", form).then((response) => {
                
                api.put("/api/roleUser", {
                    user_id: id,
                    role_id: selectedRoles.map(role => role.id)
                })
                .then((response) => {
    
                }).catch((error) => {
                    console.error(error)
                })

                Swal.fire({
                    title: "Usuário atualizado com sucesso",
                    icon: 'success',
                    confirmButtonColor: '#3c8dbc',
                })

                
                //volta para pagina inicial caso esteja editando o seu proprio usuario
                if(user.user.id == id){
                    navigate('/dashboard', { replace: true });
                }else{
                    navigate('/users', { replace: true });
                }
            }).catch((error) => {
                console.error(error)
                Swal.fire({
                    title: "Usuário não atualizado",
                    text: error.message,
                    icon: 'error',
                    confirmButtonColor: '#3c8dbc',

                })
            }).finally(() => {
                setLoading(false)
            })
        }

    }

    const screenTela =
        <>
            {loading && <LoadingBlock />}
            <ModalYesNo show={showModal} setShow={setShowModal} affirnName={"Deletar"} negName={"Voltar"} afirmativeFunc={onDelete} message={"Ao excluir um registro não será possivel recuperar"} title={"Tem certeza?"} imgSVG={Clear} />
            <form onSubmit={onSubmit}>
                <div className='screenContainer edit-mode'>
                    <h1>Usuário</h1>
                    <div className="row">
                        <h4>Dados Básicos</h4>
                        <div className="d-flex justify-content-center col-12 col-sm-4 col-lg-4">
                            <InputImage imageAvatar={Avatar} image={image} setImage={setImage} />
                        </div>
                        <div className="col-12 col-sm-4 col-lg-4 row" style={{ padding: '0px', margin: '-1px' }}>
                            <div className="col-12">
                                <label className="form-label-input">Nome*</label>
                                <input className="form-control" value={name} type="text" name="name" placeholder="Nome" onChange={value => setName(value.target.value.toUpperCase())} />
                                {error.name && <span className="error" >Campo Inválido</span>}
                            </div>
                            <div className="col-12">
                                <label className="form-label-input">Email*</label>
                                <input className="form-control" value={email} onChange={value => setEmail(value.target.value)} type="text" name="email" placeholder="Email" />
                                {error.email && <span className="error" >Campo Inválido</span>}
                            </div>
                            <div className="col-12">
                                <label className="form-label-input">CPF (opcional)</label>
                                <InputCPF className="form-control" value={cpf} onChange={value => setCpf(value)} type="text" name="cpf" placeholder="000.000.000-00" />
                            </div>
                            <div className="col-12">
                                <label className="form-label-input">Nova Senha*</label>
                                <input className="form-control" value={password} onChange={value => setPassword(value.target.value)} type="text" name="password" placeholder="Nova Senha" />
                                {error.password && <span className="error" >Campo Inválido</span>}
                            </div>

                            <div className="col-12 mt-3">
                                <Form.Check
                                    type="switch"
                                    id="professional-switch"
                                    label="Supervisor de caixa"
                                    checked={isCashier}
                                    onChange={() => setIsCashier(!isCashier)}
                                />
                            </div>

                            <div className="col-12 mt-4">
                                <h5 className="mb-3">Perfil do usuário</h5>
                                {
                                    roles.map(role => (
                                        <Form.Check
                                            key={role.id}
                                            id={role.id}
                                            type="checkbox"
                                            label={role.description}
                                            className="my-2"
                                            checked={selectedRoles.some(selectedRole => selectedRole.id === role.id)}
                                            onChange={() => handleRoleChange(role)}
                                        />
                                    ))
                                }
                                {error.selectedRoles && <span className="error">Selecione pelo menos um perfil</span>}
                            </div>

                            <div className="col-12 my-3">
                                <Form.Check
                                    type="switch"
                                    id="professional-switch"
                                    label="Profissional de consultório"
                                    checked={isDoctor}
                                    onChange={() => setIsDoctor(!isDoctor)}
                                />
                            </div>

                            {
                                isDoctor ? (
                                    <>
                                        <Dropdown>
                                            <Dropdown.Toggle id="dropdown-button" variant="light" className="w-100">
                                                Selecionar profissional
                                            </Dropdown.Toggle>
                                            {error.professional && <span className="error" >Profissional não selecionado</span>}
                                            <Dropdown.Menu className="col-11 mt-3">
                                                <Form.Control
                                                    autoFocus
                                                    className="mx-3 my-2 w-75"
                                                    placeholder="Buscar profissional"
                                                    onChange={(e) => { setProfessionalSearch(e.target.value) }}
                                                />
                                                {
                                                    professionalsList.map((professional) => {
                                                        return (
                                                            <Dropdown.Item key={professional.id} onClick={() => {
                                                                addProfessional(professional)
                                                            }}>{professional.name}</Dropdown.Item>
                                                        )
                                                    })
                                                }
                                            </Dropdown.Menu>
                                        </Dropdown>

                                        {
                                            professional && (
                                                <Card className="mt-3 flex-row align-items-center w-100">
                                                    <Card.Body>{professional.name}</Card.Body>
                                                    <CloseButton onClick={() => setProfessional("")}/>
                                                </Card>
                                            )
                                        }
                                    </>
                                ) : (
                                    null
                                )
                            }
                        </div>
                        <div className="col-12 col-sm-4 col-lg-4 row" style={{ padding: '0px', margin: '-1px' }}>
                            <div className="col-12">
                                <label className="form-label-input">Status*</label>
                                <div>
                                    <div className="form-check form-check-inline">
                                        <input onChange={() => {
                                            setStatus(true)
                                        }} className="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2" checked={status} />
                                        <label className="form-check-label" htmlFor="inlineRadio2">Ativo</label>
                                    </div>
                                    <div className="form-check form-check-inline">
                                        <input onChange={() => {
                                            setStatus(false)
                                        }} className="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1" checked={!status} />
                                        <label className="form-check-label" htmlFor="inlineRadio1">Inativo</label>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <FooterEdit navigateRoute={"/users"} onClickDel={() => {
                    setShowModal(true)
                }} />
            </form>
        </>
    
    return (
        <Menu screen={screenTela} />
    )
}

export default UsersEdit;